// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400&family=Inter:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.store-walkthrough {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  overflow: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Video */
.walkthrough-video,
.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;

  /* Video quality enhancements */
  image-rendering: -webkit-optimize-contrast;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;

  /* Smooth rendering */
  will-change: transform;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);

  /* Reduce pixelation with smooth interpolation */
  filter: contrast(1.02) saturate(1.05);
  -webkit-filter: contrast(1.02) saturate(1.05);
}

/* Add subtle sharpening for HD look */
.walkthrough-video {
  z-index: 2;
  filter: contrast(1.02) saturate(1.05) brightness(1.01);
  -webkit-filter: contrast(1.02) saturate(1.05) brightness(1.01);
}

.background-video {
  z-index: 1;
  filter: contrast(1.01) brightness(0.98);
  -webkit-filter: contrast(1.01) brightness(0.98);
}

/* High-quality scaling for modern browsers */
@supports (image-rendering: -webkit-optimize-contrast) {
  .walkthrough-video,
  .background-video {
    image-rendering: -webkit-optimize-contrast;
  }
}

/* For 4K displays - use higher resolution rendering */
@media (min-resolution: 2dppx) {
  .walkthrough-video,
  .background-video {
    transform: scale(1.001) translateZ(0);
    -webkit-transform: scale(1.001) translateZ(0);
  }
}

/* Mouse Debug */
/* Speed Control */
.speed-control {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background: linear-gradient(
    135deg,
    rgba(10, 10, 10, 0.9) 0%,
    rgba(30, 30, 30, 0.8) 100%
  );
  backdrop-filter: blur(10px);
  border: 1px solid rgba(212, 175, 55, 0.3);
  border-radius: 15px;
  padding: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 45; /* Above video controls but below modals */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.speed-control span {
  color: rgba(212, 175, 55, 0.9);
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 300;
  letter-spacing: 0.05em;
  margin-right: 0.5rem;
}

.speed-control button {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(212, 175, 55, 0.2);
  color: rgba(255, 255, 255, 0.7);
  padding: 0.4rem 0.8rem;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  transition: all 0.2s ease;
}

.speed-control button:hover {
  background: rgba(212, 175, 55, 0.1);
  border-color: rgba(212, 175, 55, 0.4);
  color: rgba(212, 175, 55, 0.9);
}

.speed-control button.active {
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.3), rgba(255, 215, 0, 0.2));
  border-color: rgba(212, 175, 55, 0.6);
  color: #d4af37;
  box-shadow: 0 0 10px rgba(212, 175, 55, 0.2);
}

/* Debug removed */

/* Sound Toggle Button */
.sound-toggle {
  position: fixed;
  top: 6rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.9);
  border: 2px solid rgba(212, 175, 55, 0.4);
  color: rgba(212, 175, 55, 0.9);
  padding: 0.8rem;
  cursor: pointer;
  font-size: 1.2rem;
  transition: all 0.2s ease;
  z-index: 35;
  clip-path: polygon(
    0 5px,
    5px 0,
    100% 0,
    100% calc(100% - 5px),
    calc(100% - 5px) 100%,
    0 100%
  );
}

.sound-toggle:hover {
  background: rgba(10, 10, 10, 0.95);
  border-color: rgba(212, 175, 55, 0.8);
}

/* Loading Overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.loading-content {
  text-align: center;
  color: white;
  max-width: 420px;
  padding: 20px;
}

.loading-content h2 {
  font-size: 2rem;
  font-weight: 300;
  letter-spacing: 0.05em;
  margin-bottom: 2rem;
  background: linear-gradient(90deg, #fff, #888);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* iOS Safari Warning Styles */
.chrome-button {
  background: linear-gradient(135deg, #4285f4, #3367d6);
  color: white;
  border: none;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.3);
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.chrome-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(66, 133, 244, 0.4);
  background: linear-gradient(135deg, #5294ff, #4377e7);
}

.continue-anyway-button {
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.continue-anyway-button:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.3);
  color: white;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-top: 2px solid #fff;
  border-radius: 50%;
  margin: 0 auto 1.5rem;
  animation: spin 1s linear infinite;
}

/* Enhanced Loading Progress */
.loading-progress-container {
  width: 300px;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  margin: 2rem auto 1rem;
  position: relative;
  overflow: hidden;
  clip-path: polygon(
    0 2px,
    2px 0,
    100% 0,
    100% calc(100% - 2px),
    calc(100% - 2px) 100%,
    0 100%
  );
}

.loading-progress-bar {
  height: 100%;
  background: linear-gradient(90deg,
    rgba(212, 175, 55, 0.8) 0%,
    rgba(255, 215, 0, 1) 50%,
    rgba(212, 175, 55, 0.8) 100%
  );
  transition: width 0.3s ease;
  box-shadow: 0 0 10px rgba(212, 175, 55, 0.5);
}

.loading-percent {
  font-family: 'Inter', sans-serif;
  font-size: 2rem;
  font-weight: 600;
  color: rgba(212, 175, 55, 0.9);
  letter-spacing: 0.1em;
  margin-bottom: 1rem;
}

.ready-state {
  margin-top: 2rem;
  animation: fadeIn 0.5s ease;
}

.ready-text {
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  color: rgba(212, 175, 55, 1);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  animation: pulse 1.5s ease infinite;
}

.enter-button {
  background: rgba(0, 0, 0, 0.9);
  border: 2px solid rgba(212, 175, 55, 0.8);
  color: white;
  padding: 1rem 2.5rem;
  font-family: 'Playfair Display', serif;
  font-size: 1.2rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  clip-path: polygon(
    0 10px,
    10px 0,
    100% 0,
    100% calc(100% - 10px),
    calc(100% - 10px) 100%,
    0 100%
  );
}

.enter-button:hover {
  background: rgba(212, 175, 55, 0.1);
  border-color: rgba(212, 175, 55, 1);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.8),
              0 0 40px rgba(212, 175, 55, 0.2);
}

/* Choice Overlay */
.choice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;
}

.choice-overlay > * {
  pointer-events: auto;
}

.persistent-header {
  position: absolute;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  pointer-events: none;
  z-index: 20;
}

/* Title Particles */
.title-particles {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 150px;
  pointer-events: none;
  overflow: visible;
}

.diamond-particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: radial-gradient(circle, rgba(212, 175, 55, 0.9) 0%, rgba(255, 215, 0, 0.6) 40%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  left: calc(50% + var(--x));
  top: calc(50% + var(--y));
  animation: luxuryFloat var(--duration) ease-in-out infinite var(--delay);
  box-shadow: 0 0 6px rgba(212, 175, 55, 0.4);
}

@keyframes luxuryFloat {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.3);
  }
  20% {
    opacity: 0.8;
    transform: translateY(0px) scale(1);
  }
  80% {
    opacity: 0.8;
    transform: translateY(-30px) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-50px) scale(0.5);
  }
}

.luxury-title {
  font-family: 'Playfair Display', serif;
  font-size: 4rem;
  font-weight: 400;
  font-style: italic;
  letter-spacing: 0.08em;
  background: linear-gradient(
    90deg,
    rgba(212, 175, 55, 1) 0%,
    rgba(255, 223, 186, 1) 25%,
    rgba(255, 215, 0, 1) 50%,
    rgba(255, 223, 186, 1) 75%,
    rgba(212, 175, 55, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  /* No animation - static elegant text */
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.luxury-subtitle {
  font-family: 'Inter', sans-serif;
  font-weight: 300;
  font-size: 1.2rem;
  color: #000000;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
}

.luxury-accent-line {
  width: 120px;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(212, 175, 55, 0.8) 25%,
    rgba(255, 215, 0, 1) 50%,
    rgba(212, 175, 55, 0.8) 75%,
    transparent 100%
  );
  margin: 0 auto;
  /* No animation - static accent line */
}

@keyframes shimmerText {
  0%, 100% {
    background-position: 0% center;
  }
  50% {
    background-position: 100% center;
  }
}

@keyframes pulseWidth {
  0%, 100% {
    transform: scaleX(1);
    opacity: 0.8;
  }
  50% {
    transform: scaleX(1.2);
    opacity: 1;
  }
}

/* Navigation Grid System */
.navigation-grid {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-columns: repeat(2, 200px);
  grid-template-rows: repeat(2, 100px);
  gap: 20px;
  z-index: 20;
}

.nav-button {
  background: rgba(0, 0, 0, 0.9);
  border: 2px solid rgba(212, 175, 55, 0.5);
  clip-path: polygon(
    12px 0,
    100% 0,
    100% calc(100% - 12px),
    calc(100% - 12px) 100%,
    0 100%,
    0 12px
  );
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.nav-button:hover {
  background: rgba(10, 10, 10, 0.95);
  border-color: rgba(212, 175, 55, 0.9);
  transform: translateY(-2px);
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.8),
    0 0 0 1px rgba(212, 175, 55, 0.3) inset;
}

.nav-button.visited {
  background: rgba(0, 0, 0, 0.7);
  border-color: rgba(212, 175, 55, 0.3);
}

.nav-icon {
  font-size: 2.5rem;
  color: rgba(212, 175, 55, 0.9);
  margin-bottom: 0.5rem;
}

.nav-button h3 {
  font-family: 'Playfair Display', serif;
  font-size: 0.9rem;
  font-weight: 400;
  letter-spacing: 0.08em;
  margin: 0;
  color: white;
  text-align: center;
}

.visited-indicator {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 0.6rem;
  color: rgba(212, 175, 55, 0.7);
  letter-spacing: 0.1em;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
}

/* Legacy button styles - removed */

/* Remove old hotspot styles */
.hotspot-button:hover {
  background: linear-gradient(
    135deg,
    rgba(30, 30, 30, 0.9) 0%,
    rgba(50, 50, 50, 0.8) 100%
  );
  border-color: rgba(212, 175, 55, 0.7);
  transform: translate(-50%, -50%) scale(1.1);
  box-shadow:
    0 8px 40px rgba(0, 0, 0, 0.7),
    0 0 40px rgba(212, 175, 55, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

/* Remove old hotspot button animations */
.hotspot-glow {
  display: none;
}

/* Inventory Modal */
.inventory-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.95) 0%,
    rgba(10, 10, 10, 0.98) 100%
  );
  backdrop-filter: blur(30px) saturate(200%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 80;
  animation: fadeIn 0.3s ease;
}

.inventory-container {
  background: linear-gradient(
    145deg,
    rgba(15, 15, 15, 0.98) 0%,
    rgba(25, 25, 25, 0.95) 50%,
    rgba(15, 15, 15, 0.98) 100%
  );
  border-radius: 0;
  padding: 3rem;
  max-width: 1200px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  border: 1px solid rgba(212, 175, 55, 0.4);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 25px 80px rgba(0, 0, 0, 0.8),
    0 10px 25px rgba(0, 0, 0, 0.9),
    0 0 100px rgba(212, 175, 55, 0.1);
  clip-path: polygon(
    20px 0,
    100% 0,
    100% calc(100% - 20px),
    calc(100% - 20px) 100%,
    0 100%,
    0 20px
  );
}

.inventory-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.05) 0%,
    transparent 100%
  );
  pointer-events: none;
}

.inventory-container h2 {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 2rem;
  letter-spacing: 0.08em;
  background: linear-gradient(90deg, #d4af37, #fff, #d4af37);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.inventory-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.product-card {
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.02) 100%
  );
  border: 1px solid rgba(212, 175, 55, 0.2);
  border-radius: 0;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  clip-path: polygon(
    10px 0,
    100% 0,
    100% calc(100% - 10px),
    calc(100% - 10px) 100%,
    0 100%,
    0 10px
  );
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.05) inset,
    0 4px 12px rgba(0, 0, 0, 0.3);
}

.product-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(255, 255, 255, 0.1) 50%,
    transparent 70%
  );
  transform: rotate(45deg) translateY(-100%);
  transition: transform 0.6s ease;
  pointer-events: none;
}

.product-card:hover {
  transform: translateY(-5px) scale(1.02);
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.12) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  border-color: rgba(212, 175, 55, 0.5);
  box-shadow:
    0 0 0 1px rgba(212, 175, 55, 0.3) inset,
    0 8px 25px rgba(0, 0, 0, 0.5),
    0 0 40px rgba(212, 175, 55, 0.1);
}

.product-card:hover::before {
  transform: rotate(45deg) translateY(100%);
}

.product-card.out-of-stock {
  opacity: 0.6;
}

.product-image {
  font-size: 4rem;
  text-align: center;
  margin-bottom: 1rem;
}

.product-card h3 {
  color: white;
  font-size: 1.3rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
}

.product-price {
  color: #ffd700;
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.product-desc {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

.stock-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(255, 0, 0, 0.8);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
}

.inventory-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.glass-button {
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.05) 50%,
    rgba(255, 255, 255, 0.08) 100%
  );
  border: 1px solid rgba(212, 175, 55, 0.4);
  color: white;
  padding: 1rem 2.5rem;
  cursor: pointer;
  font-size: 1rem;
  font-family: 'Inter', sans-serif;
  font-weight: 300;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  clip-path: polygon(
    15px 0,
    100% 0,
    100% calc(100% - 15px),
    calc(100% - 15px) 100%,
    0 100%,
    0 15px
  );
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 4px 15px rgba(0, 0, 0, 0.5),
    0 0 30px rgba(212, 175, 55, 0.1);
}

.button-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 100%
  );
  transition: left 0.5s ease;
  pointer-events: none;
}

.glass-button:hover .button-shine {
  left: 100%;
}

.action-btn {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 1rem 2rem;
  border-radius: 50px;
  cursor: pointer;
  font-size: 1rem;
  letter-spacing: 0.02em;
  transition: all 0.3s ease;
}

.glass-button:hover {
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0.15) 100%
  );
  border-color: rgba(212, 175, 55, 0.6);
  transform: translateY(-2px) scale(1.02);
  box-shadow:
    0 0 0 1px rgba(212, 175, 55, 0.3) inset,
    0 8px 25px rgba(0, 0, 0, 0.7),
    0 0 50px rgba(212, 175, 55, 0.2);
}

.action-btn:hover {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.08) 100%);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Product Detail Modal */
.product-detail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 90;
  animation: fadeIn 0.3s ease;
}

.product-detail {
  background: rgba(10, 10, 10, 0.4);
  backdrop-filter: blur(30px) saturate(200%);
  border-radius: 0;
  padding: 3rem;
  max-width: 900px;
  width: 90%;
  position: relative;
  border: 2px solid rgba(212, 175, 55, 0.5);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 30px 90px rgba(0, 0, 0, 0.9),
    0 15px 35px rgba(0, 0, 0, 0.8),
    0 0 120px rgba(212, 175, 55, 0.15);
  clip-path: polygon(
    30px 0,
    100% 0,
    100% calc(100% - 30px),
    calc(100% - 30px) 100%,
    0 100%,
    0 30px
  );
}

/* No gradient background - clean design */

.product-showcase {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 3rem;
  align-items: center;
}

.product-360 {
  text-align: center;
}

.rotating-product {
  font-size: 8rem;
  display: inline-block;
  color: #d4af37;
  transition: transform 0.3s ease;
  /* No animation - static display */
}

.rotate-hint {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;
  margin-top: 1rem;
}

.product-info h1 {
  color: white;
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 1rem;
  letter-spacing: 0.02em;
}

.product-info .price {
  color: #ffd700;
  font-size: 1.8rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.product-info .description {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.product-actions {
  display: flex;
  gap: 1rem;
}

.btn-primary,
.btn-secondary {
  padding: 1rem 2rem;
  border-radius: 50px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.02em;
}

.btn-primary {
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.08) 50%,
    rgba(255, 255, 255, 0.12) 100%
  );
  color: #d4af37;
  font-weight: 500;
  border: 1px solid rgba(212, 175, 55, 0.5);
}

.btn-primary:hover {
  background: linear-gradient(
    145deg,
    rgba(212, 175, 55, 0.25) 0%,
    rgba(212, 175, 55, 0.15) 50%,
    rgba(212, 175, 55, 0.2) 100%
  );
  transform: translateY(-2px) scale(1.02);
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.4),
    0 0 40px rgba(212, 175, 55, 0.15);
  border-color: rgba(212, 175, 55, 0.7);
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

.sold-out-message p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 1rem;
  font-style: italic;
}

/* Close Button */
.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  border: 1px solid rgba(212, 175, 55, 0.3);
  color: #d4af37;
  width: 45px;
  height: 45px;
  font-size: 1.8rem;
  cursor: pointer;
  transition: all 0.3s ease;
  clip-path: polygon(
    8px 0,
    100% 0,
    100% calc(100% - 8px),
    calc(100% - 8px) 100%,
    0 100%,
    0 8px
  );
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 4px 12px rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: linear-gradient(
    145deg,
    rgba(212, 175, 55, 0.2) 0%,
    rgba(212, 175, 55, 0.1) 100%
  );
  transform: rotate(90deg) scale(1.1);
  border-color: rgba(212, 175, 55, 0.5);
  box-shadow:
    0 0 0 1px rgba(212, 175, 55, 0.3) inset,
    0 6px 20px rgba(0, 0, 0, 0.7),
    0 0 30px rgba(212, 175, 55, 0.2);
}

/* Playing Indicator */
.playing-indicator {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(212, 175, 55, 0.4);
  border-radius: 0;
  clip-path: polygon(
    0 8px,
    8px 0,
    100% 0,
    100% calc(100% - 8px),
    calc(100% - 8px) 100%,
    0 100%
  );
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  z-index: 60;
  animation: slideDown 0.5s ease;
}

.playing-dot {
  width: 8px;
  height: 8px;
  background: #ff4444;
  border-radius: 50%;
  animation: pulse 1.5s ease infinite;
}

.playing-indicator span {
  color: rgba(212, 175, 55, 0.9);
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  letter-spacing: 0.05em;
  font-weight: 300;
}

/* Location Indicator */
.location-indicator {
  position: fixed;
  bottom: 8rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(212, 175, 55, 0.4);
  clip-path: polygon(
    0 10px,
    10px 0,
    100% 0,
    100% calc(100% - 10px),
    calc(100% - 10px) 100%,
    0 100%
  );
  padding: 1.5rem 2rem;
  z-index: 35;
  animation: slideUp 0.5s ease;
}

.location-indicator h3 {
  font-family: 'Playfair Display', serif;
  color: rgba(212, 175, 55, 0.9);
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 1rem;
  text-align: center;
  letter-spacing: 0.05em;
}

.location-actions {
  display: flex;
  gap: 1rem;
}

.location-actions button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.location-actions button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

/* Sharp Mini Map */
.sharp-minimap {
  position: fixed;
  top: 5rem;
  left: 1rem;
  background: rgba(0, 0, 0, 0.95);
  border: 2px solid rgba(212, 175, 55, 0.4);
  clip-path: polygon(
    0 10px,
    10px 0,
    100% 0,
    100% calc(100% - 10px),
    calc(100% - 10px) 100%,
    0 100%
  );
  padding: 1rem;
  width: 220px;
  z-index: 50;
  box-shadow:
    0 0 0 1px rgba(212, 175, 55, 0.2),
    0 4px 12px rgba(0, 0, 0, 0.8);
}

.map-title {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  color: rgba(212, 175, 55, 0.9);
  text-transform: uppercase;
  margin-bottom: 0.5rem;
  padding-bottom: 0.3rem;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
}

.map-svg {
  width: 100%;
  height: 120px;
  background: rgba(0, 0, 0, 0.5);
}

.map-node {
  transition: all 0.3s ease;
}

.map-node.active rect {
  fill: rgba(212, 175, 55, 0.3);
  stroke: rgba(212, 175, 55, 1);
  stroke-width: 2;
  filter: drop-shadow(0 0 4px rgba(212, 175, 55, 0.8));
}

.map-node.visited rect {
  stroke-dasharray: 5,2;
}

.map-legend {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(212, 175, 55, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.current-loc {
  font-family: 'Inter', sans-serif;
  font-size: 0.65rem;
  color: rgba(212, 175, 55, 0.8);
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

/* Old mini-map styles removed - sharp-minimap is always visible */

.map-point {
  position: absolute;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  transition: all 0.3s ease;
}

.map-point.entrance {
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.map-point.diamonds {
  top: 10px;
  left: 20%;
}

.map-point.watches {
  top: 10px;
  right: 20%;
}

.map-point.active {
  background: rgba(255, 215, 0, 0.8);
  border-color: #ffd700;
  box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
}

.map-point span {
  color: white;
  font-size: 0.7rem;
}

.map-path {
  position: absolute;
  width: 2px;
  background: rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.map-path.left {
  height: 70px;
  bottom: 30px;
  left: 30%;
  transform: rotate(-20deg);
}

.map-path.right {
  height: 70px;
  bottom: 30px;
  right: 30%;
  transform: rotate(20deg);
}

.map-path.active {
  background: rgba(255, 215, 0, 0.6);
}

/* Ambient Glow */
.ambient-glow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 5;
  opacity: 0.3;
}

.diamond-glow {
  background: radial-gradient(circle at center,
    rgba(135, 206, 235, 0.2) 0%,
    transparent 70%);
  animation: glowPulse 4s ease infinite;
}

.watch-glow {
  background: radial-gradient(circle at center,
    rgba(255, 215, 0, 0.2) 0%,
    transparent 70%);
  animation: glowPulse 4s ease infinite;
}

/* Animations */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes pulse-ring {
  0% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.3;
  }
  100% {
    transform: translate(-50%, -50%) scale(0.8);
    opacity: 1;
  }
}

@keyframes gentleSpin {
  from { transform: rotateY(0deg); }
  to { transform: rotateY(360deg); }
}

@keyframes glowPulse {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.5; }
}

/* ========================================
   RESPONSIVE DESIGN - Mobile First Approach
   ======================================== */

/* Tablet and smaller (768px and below) */
@media (max-width: 768px) {
  /* Speed control adjustments - move to safe area */
  .speed-control {
    position: fixed;
    bottom: auto;
    top: auto;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
    bottom: 100px; /* Above the bottom controls */
    padding: 0.5rem 0.8rem;
    gap: 0.4rem;
    z-index: 50; /* Ensure it's above other elements */
    background: linear-gradient(
      135deg,
      rgba(10, 10, 10, 0.95),
      rgba(20, 20, 20, 0.9)
    );
    flex-direction: row;
    align-items: center;
    max-width: 90%;
  }

  .speed-control span {
    font-size: 0.75rem;
    display: inline-block;
    margin-right: 0.5rem;
  }

  .speed-control button {
    padding: 0.3rem 0.5rem;
    font-size: 0.75rem;
    min-width: 35px;
  }
  .persistent-header {
    top: 1rem;
  }

  .luxury-title {
    font-size: 2.5rem;
  }

  .luxury-subtitle {
    font-size: 1rem;
  }


  .inventory-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
  }

  .product-showcase {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .product-detail {
    padding: 2rem;
    width: 95%;
  }

  .location-indicator {
    bottom: 1rem;
    padding: 1rem;
    width: 90%;
  }

  .location-actions {
    flex-direction: row;
    gap: 0.5rem;
  }

  .location-actions button {
    padding: 0.5rem 1rem;
    font-size: 0.85rem;
  }
}

/* Mobile (480px and below) */
@media (max-width: 480px) {
  /* Adjust speed control for small mobile screens */
  .speed-control {
    position: fixed;
    bottom: 90px; /* Above bottom navigation */
    left: 50%;
    transform: translateX(-50%);
    padding: 0.4rem 0.6rem;
    gap: 0.3rem;
    max-width: 280px;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    background: linear-gradient(
      135deg,
      rgba(10, 10, 10, 0.98),
      rgba(20, 20, 20, 0.95)
    );
    border: 1px solid rgba(212, 175, 55, 0.3);
    display: flex !important; /* Ensure it's visible */
    align-items: center;
    justify-content: center;
    z-index: 45; /* Below modals but above video */
  }

  .speed-control span {
    font-size: 0.7rem;
    margin-right: 0.3rem;
    color: rgba(212, 175, 55, 0.9);
  }

  .speed-control button {
    padding: 0.25rem 0.35rem;
    font-size: 0.65rem;
    min-width: 28px;
  }

  .speed-icon {
    font-size: 0.9rem;
    margin-right: 0.3rem;
  }
  .luxury-title {
    font-size: 2rem;
  }

  .luxury-subtitle {
    font-size: 0.9rem;
    letter-spacing: 0.2em;
  }


  .inventory-grid {
    grid-template-columns: 1fr;
    padding: 0 1rem;
  }

  .inventory-modal {
    padding: 0;
  }

  .inventory-container {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    padding: 4rem 1rem 1rem;
    border: none;
    clip-path: none;
    border-radius: 0;
    overflow-y: auto;
  }

  .inventory-container h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .product-card {
    padding: 1.2rem;
  }

  .product-detail-modal {
    padding: 0;
  }

  .product-detail {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    padding: 4rem 1rem 1rem;
    border: none;
    clip-path: none;
    border-radius: 0;
    overflow-y: auto;
  }

  .product-showcase {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .rotating-product {
    font-size: 5rem;
  }

  .close-btn {
    position: fixed;
    top: 1rem;
    right: 1rem;
    padding: 0.8rem;
    font-size: 1.5rem;
    background: rgba(0, 0, 0, 0.95);
    border: 2px solid rgba(212, 175, 55, 0.6);
    z-index: 100;
  }

  .playing-indicator {
    bottom: 1rem;
    left: 1rem;
    right: auto;
    transform: none;
    padding: 0.5rem 0.8rem;
    font-size: 0.8rem;
    max-width: 180px;
  }

  .playing-indicator span {
    font-size: 0.8rem;
  }

  /* Location indicator adjustments */
  .location-indicator {
    bottom: 10rem;
    left: 50%;
    transform: translateX(-50%);
    width: 85%;
    padding: 0.8rem;
  }
}

/* iPhone SE and similar small phones (375px and below) */
@media (max-width: 375px) {
  /* Critical mobile layout - no overlaps */

  /* Speed control - keep visible but adjust position */
  .speed-control {
    bottom: 75px !important; /* Position carefully above controls */
    padding: 0.35rem 0.5rem !important;
    gap: 0.25rem !important;
  }

  /* Playing indicator - bottom left */
  .playing-indicator {
    bottom: 0.5rem;
    left: 0.5rem;
    padding: 0.4rem 0.6rem;
    font-size: 0.7rem;
    max-width: 150px;
  }

  .playing-indicator span {
    font-size: 0.65rem;
  }

  .walking-icon {
    font-size: 0.7rem;
  }

  /* Location indicator - above playing indicator */
  .location-indicator {
    bottom: 3.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    padding: 0.6rem;
  }

  .location-indicator h3 {
    font-size: 0.8rem;
  }

  /* Navigation grid - centered */
  .navigation-grid {
    top: 55%;
  }

  /* Sound toggle - bottom right */
  .sound-toggle {
    position: fixed;
    bottom: 0.5rem;
    right: 0.5rem;
    padding: 0.5rem;
    font-size: 1rem;
    z-index: 35;
  }
  .persistent-header {
    top: 0.5rem;
  }

  .luxury-title {
    font-size: 1.8rem;
  }

  .luxury-subtitle {
    font-size: 0.8rem;
    letter-spacing: 0.15em;
    margin-bottom: 1rem;
  }

  .luxury-accent-line {
    width: 80px;
  }

  .title-particles {
    width: 300px;
    height: 100px;
  }


  .inventory-container {
    padding: 1.5rem 1rem;
    width: 100%;
    max-width: 100%;
    height: 100vh;
    overflow-y: auto;
  }

  .inventory-container h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .product-card h3 {
    font-size: 1rem;
  }

  .product-price {
    font-size: 0.9rem;
  }

  .product-detail {
    padding: 1.5rem;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
  }

  .product-info h1 {
    font-size: 1.5rem;
  }

  .product-360 {
    margin-bottom: 1rem;
  }

  .rotating-product {
    font-size: 5rem;
  }

  .playing-indicator {
    bottom: 1rem;
    padding: 0.4rem 0.8rem;
    width: 95%;
  }

  .walking-icon {
    font-size: 0.8rem;
  }

  .location-indicator {
    bottom: 0.5rem;
    padding: 0.8rem;
    width: 95%;
  }

  .location-indicator h3 {
    font-size: 0.9rem;
  }

  .location-actions {
    flex-direction: column;
    width: 100%;
  }

  .location-actions button {
    width: 100%;
    padding: 0.6rem;
    font-size: 0.8rem;
  }

  .close-btn {
    top: 0.5rem;
    right: 0.5rem;
    padding: 0.5rem;
  }


  /* Responsive Grid for Tablets */
@media (max-width: 768px) {
  .navigation-grid {
    grid-template-columns: repeat(2, 160px);
    grid-template-rows: repeat(2, 90px);
    gap: 15px;
  }

  .nav-button {
    padding: 1.2rem;
  }

  .nav-icon {
    font-size: 2rem;
  }

  .nav-button h3 {
    font-size: 0.85rem;
  }
}

/* Responsive Grid for Mobile */
@media (max-width: 480px) {
  .navigation-grid {
    grid-template-columns: repeat(2, 140px);
    grid-template-rows: repeat(2, 80px);
    gap: 12px;
  }

  .nav-button {
    padding: 1rem;
  }

  .nav-icon {
    font-size: 1.8rem;
    margin-bottom: 0.3rem;
  }

  .nav-button h3 {
    font-size: 0.75rem;
  }

  .visited-indicator {
    font-size: 0.5rem;
    top: 3px;
    right: 5px;
  }
}

/* Additional fix for navigation grid on small screens */
@media (max-width: 375px) {
  .navigation-grid {
    grid-template-columns: repeat(2, 110px);
    grid-template-rows: repeat(2, 70px);
    gap: 8px;
    top: 50%;
  }

  .nav-button {
    padding: 0.8rem;
    clip-path: polygon(
      8px 0,
      100% 0,
      100% calc(100% - 8px),
      calc(100% - 8px) 100%,
      0 100%,
      0 8px
    );
  }

  .nav-icon {
    font-size: 1.5rem;
    margin-bottom: 0.2rem;
  }

  .nav-button h3 {
    font-size: 0.65rem;
    letter-spacing: 0.05em;
  }

  .visited-indicator {
    display: none; /* Hide on very small screens */
  }

  .nav-button.visited::after {
    content: '';
    position: absolute;
    top: 3px;
    right: 3px;
    width: 6px;
    height: 6px;
    background: rgba(212, 175, 55, 0.8);
    border-radius: 50%;
  }
}

/* Responsive minimap */
  .sharp-minimap {
    top: 4.5rem;
    width: 180px;
    padding: 0.7rem;
  }

  .map-svg {
    height: 90px;
  }

  .map-title {
    font-size: 0.6rem;
  }

  .current-loc {
    font-size: 0.6rem;
  }

  .loading-content h2 {
    font-size: 1.3rem;
  }

  .loading-content p {
    font-size: 0.8rem;
  }
}

/* Floor Plan Controls */
.map-close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: transparent;
  border: 1px solid rgba(212, 175, 55, 0.4);
  color: rgba(212, 175, 55, 0.8);
  padding: 0.2rem 0.3rem;
  cursor: pointer;
  font-size: 0.8rem;
  transition: all 0.2s ease;
  z-index: 10;
}

.map-close-btn:hover {
  background: rgba(212, 175, 55, 0.1);
  color: rgba(212, 175, 55, 1);
}

.floor-plan-toggle {
  position: fixed;
  top: 6rem;
  left: 1rem;
  background: rgba(0, 0, 0, 0.9);
  border: 2px solid rgba(212, 175, 55, 0.4);
  color: rgba(212, 175, 55, 0.9);
  padding: 0.8rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  transition: all 0.2s ease;
  z-index: 40;
  clip-path: polygon(
    0 8px,
    8px 0,
    100% 0,
    100% calc(100% - 8px),
    calc(100% - 8px) 100%,
    0 100%
  );
}

.floor-plan-toggle:hover {
  background: rgba(10, 10, 10, 0.95);
  border-color: rgba(212, 175, 55, 0.8);
  transform: translateX(2px);
}

.floor-plan-toggle svg {
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/StoreWalkthrough/StoreWalkthrough.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,+EAA+E;AACjF;;AAEA,UAAU;AACV;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;;EAEhB,+BAA+B;EAC/B,0CAA0C;EAC1C,iCAAiC;EACjC,4BAA4B;;EAE5B,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,wBAAwB;EACxB,gCAAgC;;EAEhC,gDAAgD;EAChD,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,sDAAsD;EACtD,8DAA8D;AAChE;;AAEA;EACE,UAAU;EACV,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA,6CAA6C;AAC7C;EACE;;IAEE,0CAA0C;EAC5C;AACF;;AAEA,sDAAsD;AACtD;EACE;;IAEE,qCAAqC;IACrC,6CAA6C;EAC/C;AACF;;AAEA,gBAAgB;AAChB,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX;;;;GAIC;EACD,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW,EAAE,0CAA0C;EACvD,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,oFAAoF;EACpF,qCAAqC;EACrC,cAAc;EACd,4CAA4C;AAC9C;;AAEA,kBAAkB;;AAElB,wBAAwB;AACxB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX;;;;;;;GAOC;AACH;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,8CAA8C;EAC9C,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;;GAOC;AACH;;AAEA;EACE,YAAY;EACZ;;;;GAIC;EACD,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB;;;;;;;GAOC;AACH;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,2BAA2B;EAC3B;8CAC4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,4GAA4G;EAC5G,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,wEAAwE;EACxE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,YAAY;IACZ,mCAAmC;EACrC;EACA;IACE,YAAY;IACZ,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,uCAAuC;EACzC;AACF;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB;;;;;;;GAOC;EACD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX;;;;;;;GAOC;EACD,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC;;;;;;;GAOC;EACD,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,2BAA2B;EAC3B;;2CAEyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,mCAAmC;;AAEnC,8BAA8B;AAC9B;EACE;;;;GAIC;EACD,qCAAqC;EACrC,2CAA2C;EAC3C;;;0CAGwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE;;;;;GAKC;EACD,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC;;;;qCAImC;EACnC;;;;;;;GAOC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb;;;;GAIC;EACD,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0DAA0D;EAC1D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;;;GAIC;EACD,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;;GAOC;EACD;;iCAE+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0CAA0C;EAC1C,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC;;;;GAIC;EACD,qCAAqC;EACrC;;;oCAGkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;;;;;GAKC;EACD,yCAAyC;EACzC,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB;;;;;;;GAOC;EACD;;;oCAGkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;mCAEiC;EACjC,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE;;;;;GAKC;EACD,qCAAqC;EACrC,uCAAuC;EACvC;;;oCAGkC;AACpC;;AAEA;EACE;;mCAEiC;EACjC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC;;;;sCAIoC;EACpC;;;;;;;GAOC;AACH;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;;;;;GAKC;EACD,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;;;;;GAKC;EACD,uCAAuC;EACvC;;qCAEmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX;;;;GAIC;EACD,yCAAyC;EACzC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB;;;;;;;GAOC;EACD;;iCAE+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;;;;GAIC;EACD,mCAAmC;EACnC,qCAAqC;EACrC;;;oCAGkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB;;;;;;;GAOC;EACD,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,yCAAyC;EACzC;;;;;;;GAOC;EACD,oBAAoB;EACpB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,yCAAyC;EACzC;;;;;;;GAOC;EACD,aAAa;EACb,YAAY;EACZ,WAAW;EACX;;iCAE+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,kEAAkE;;AAElE;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE;;oBAEkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;;oBAEkB;EAClB,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,YAAY;EACd;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,0BAA0B,EAAE;AACnC;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;;6CAE6C;;AAE7C,yCAAyC;AACzC;EACE,kDAAkD;EAClD;IACE,eAAe;IACf,YAAY;IACZ,SAAS;IACT,WAAW;IACX,SAAS;IACT,2BAA2B;IAC3B,aAAa,EAAE,8BAA8B;IAC7C,sBAAsB;IACtB,WAAW;IACX,WAAW,EAAE,qCAAqC;IAClD;;;;KAIC;IACD,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,2DAA2D;IAC3D,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA,6BAA6B;AAC7B;EACE,kDAAkD;EAClD;IACE,eAAe;IACf,YAAY,EAAE,4BAA4B;IAC1C,SAAS;IACT,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;IACnC;;;;KAIC;IACD,yCAAyC;IACzC,wBAAwB,EAAE,wBAAwB;IAClD,mBAAmB;IACnB,uBAAuB;IACvB,WAAW,EAAE,iCAAiC;EAChD;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;;EAGA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,yDAAyD;AACzD;EACE,yCAAyC;;EAEzC,qDAAqD;EACrD;IACE,uBAAuB,EAAE,sCAAsC;IAC/D,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA,oCAAoC;EACpC;IACE,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iDAAiD;EACjD;IACE,cAAc;IACd,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,QAAQ;EACV;;EAEA,gCAAgC;EAChC;IACE,eAAe;IACf,cAAc;IACd,aAAa;IACb,eAAe;IACf,eAAe;IACf,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;;EAGA;IACE,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;;EAGA,gCAAgC;AAClC;EACE;IACE,uCAAuC;IACvC,mCAAmC;IACnC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,uCAAuC;IACvC,mCAAmC;IACnC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,uCAAuC;IACvC,mCAAmC;IACnC,QAAQ;IACR,QAAQ;EACV;;EAEA;IACE,eAAe;IACf;;;;;;;KAOC;EACH;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa,EAAE,+BAA+B;EAChD;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,kBAAkB;EACpB;AACF;;AAEA,uBAAuB;EACrB;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,yCAAyC;EACzC,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;EAC9B,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX;;;;;;;GAOC;AACH;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400&family=Inter:wght@300;400;500&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.store-walkthrough {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #000;\n  overflow: hidden;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Video */\n.walkthrough-video,\n.background-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #000;\n\n  /* Video quality enhancements */\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: -moz-crisp-edges;\n  image-rendering: crisp-edges;\n\n  /* Smooth rendering */\n  will-change: transform;\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n  transform: translateZ(0);\n  -webkit-transform: translateZ(0);\n\n  /* Reduce pixelation with smooth interpolation */\n  filter: contrast(1.02) saturate(1.05);\n  -webkit-filter: contrast(1.02) saturate(1.05);\n}\n\n/* Add subtle sharpening for HD look */\n.walkthrough-video {\n  z-index: 2;\n  filter: contrast(1.02) saturate(1.05) brightness(1.01);\n  -webkit-filter: contrast(1.02) saturate(1.05) brightness(1.01);\n}\n\n.background-video {\n  z-index: 1;\n  filter: contrast(1.01) brightness(0.98);\n  -webkit-filter: contrast(1.01) brightness(0.98);\n}\n\n/* High-quality scaling for modern browsers */\n@supports (image-rendering: -webkit-optimize-contrast) {\n  .walkthrough-video,\n  .background-video {\n    image-rendering: -webkit-optimize-contrast;\n  }\n}\n\n/* For 4K displays - use higher resolution rendering */\n@media (min-resolution: 2dppx) {\n  .walkthrough-video,\n  .background-video {\n    transform: scale(1.001) translateZ(0);\n    -webkit-transform: scale(1.001) translateZ(0);\n  }\n}\n\n/* Mouse Debug */\n/* Speed Control */\n.speed-control {\n  position: fixed;\n  bottom: 2rem;\n  right: 2rem;\n  background: linear-gradient(\n    135deg,\n    rgba(10, 10, 10, 0.9) 0%,\n    rgba(30, 30, 30, 0.8) 100%\n  );\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(212, 175, 55, 0.3);\n  border-radius: 15px;\n  padding: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  z-index: 45; /* Above video controls but below modals */\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n}\n\n.speed-control span {\n  color: rgba(212, 175, 55, 0.9);\n  font-family: 'Inter', sans-serif;\n  font-size: 0.9rem;\n  font-weight: 300;\n  letter-spacing: 0.05em;\n  margin-right: 0.5rem;\n}\n\n.speed-control button {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(212, 175, 55, 0.2);\n  color: rgba(255, 255, 255, 0.7);\n  padding: 0.4rem 0.8rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 0.85rem;\n  transition: all 0.2s ease;\n}\n\n.speed-control button:hover {\n  background: rgba(212, 175, 55, 0.1);\n  border-color: rgba(212, 175, 55, 0.4);\n  color: rgba(212, 175, 55, 0.9);\n}\n\n.speed-control button.active {\n  background: linear-gradient(135deg, rgba(212, 175, 55, 0.3), rgba(255, 215, 0, 0.2));\n  border-color: rgba(212, 175, 55, 0.6);\n  color: #d4af37;\n  box-shadow: 0 0 10px rgba(212, 175, 55, 0.2);\n}\n\n/* Debug removed */\n\n/* Sound Toggle Button */\n.sound-toggle {\n  position: fixed;\n  top: 6rem;\n  right: 1rem;\n  background: rgba(0, 0, 0, 0.9);\n  border: 2px solid rgba(212, 175, 55, 0.4);\n  color: rgba(212, 175, 55, 0.9);\n  padding: 0.8rem;\n  cursor: pointer;\n  font-size: 1.2rem;\n  transition: all 0.2s ease;\n  z-index: 35;\n  clip-path: polygon(\n    0 5px,\n    5px 0,\n    100% 0,\n    100% calc(100% - 5px),\n    calc(100% - 5px) 100%,\n    0 100%\n  );\n}\n\n.sound-toggle:hover {\n  background: rgba(10, 10, 10, 0.95);\n  border-color: rgba(212, 175, 55, 0.8);\n}\n\n/* Loading Overlay */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.loading-content {\n  text-align: center;\n  color: white;\n  max-width: 420px;\n  padding: 20px;\n}\n\n.loading-content h2 {\n  font-size: 2rem;\n  font-weight: 300;\n  letter-spacing: 0.05em;\n  margin-bottom: 2rem;\n  background: linear-gradient(90deg, #fff, #888);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* iOS Safari Warning Styles */\n.chrome-button {\n  background: linear-gradient(135deg, #4285f4, #3367d6);\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(66, 133, 244, 0.3);\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chrome-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(66, 133, 244, 0.4);\n  background: linear-gradient(135deg, #5294ff, #4377e7);\n}\n\n.continue-anyway-button {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 8px 20px;\n  font-size: 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.continue-anyway-button:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: white;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-top: 2px solid #fff;\n  border-radius: 50%;\n  margin: 0 auto 1.5rem;\n  animation: spin 1s linear infinite;\n}\n\n/* Enhanced Loading Progress */\n.loading-progress-container {\n  width: 300px;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  margin: 2rem auto 1rem;\n  position: relative;\n  overflow: hidden;\n  clip-path: polygon(\n    0 2px,\n    2px 0,\n    100% 0,\n    100% calc(100% - 2px),\n    calc(100% - 2px) 100%,\n    0 100%\n  );\n}\n\n.loading-progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg,\n    rgba(212, 175, 55, 0.8) 0%,\n    rgba(255, 215, 0, 1) 50%,\n    rgba(212, 175, 55, 0.8) 100%\n  );\n  transition: width 0.3s ease;\n  box-shadow: 0 0 10px rgba(212, 175, 55, 0.5);\n}\n\n.loading-percent {\n  font-family: 'Inter', sans-serif;\n  font-size: 2rem;\n  font-weight: 600;\n  color: rgba(212, 175, 55, 0.9);\n  letter-spacing: 0.1em;\n  margin-bottom: 1rem;\n}\n\n.ready-state {\n  margin-top: 2rem;\n  animation: fadeIn 0.5s ease;\n}\n\n.ready-text {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  color: rgba(212, 175, 55, 1);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  margin-bottom: 1.5rem;\n  animation: pulse 1.5s ease infinite;\n}\n\n.enter-button {\n  background: rgba(0, 0, 0, 0.9);\n  border: 2px solid rgba(212, 175, 55, 0.8);\n  color: white;\n  padding: 1rem 2.5rem;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.2rem;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  clip-path: polygon(\n    0 10px,\n    10px 0,\n    100% 0,\n    100% calc(100% - 10px),\n    calc(100% - 10px) 100%,\n    0 100%\n  );\n}\n\n.enter-button:hover {\n  background: rgba(212, 175, 55, 0.1);\n  border-color: rgba(212, 175, 55, 1);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.8),\n              0 0 40px rgba(212, 175, 55, 0.2);\n}\n\n/* Choice Overlay */\n.choice-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.choice-overlay > * {\n  pointer-events: auto;\n}\n\n.persistent-header {\n  position: absolute;\n  top: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n  pointer-events: none;\n  z-index: 20;\n}\n\n/* Title Particles */\n.title-particles {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 400px;\n  height: 150px;\n  pointer-events: none;\n  overflow: visible;\n}\n\n.diamond-particle {\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  background: radial-gradient(circle, rgba(212, 175, 55, 0.9) 0%, rgba(255, 215, 0, 0.6) 40%, transparent 70%);\n  border-radius: 50%;\n  opacity: 0;\n  left: calc(50% + var(--x));\n  top: calc(50% + var(--y));\n  animation: luxuryFloat var(--duration) ease-in-out infinite var(--delay);\n  box-shadow: 0 0 6px rgba(212, 175, 55, 0.4);\n}\n\n@keyframes luxuryFloat {\n  0% {\n    opacity: 0;\n    transform: translateY(20px) scale(0.3);\n  }\n  20% {\n    opacity: 0.8;\n    transform: translateY(0px) scale(1);\n  }\n  80% {\n    opacity: 0.8;\n    transform: translateY(-30px) scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-50px) scale(0.5);\n  }\n}\n\n.luxury-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 4rem;\n  font-weight: 400;\n  font-style: italic;\n  letter-spacing: 0.08em;\n  background: linear-gradient(\n    90deg,\n    rgba(212, 175, 55, 1) 0%,\n    rgba(255, 223, 186, 1) 25%,\n    rgba(255, 215, 0, 1) 50%,\n    rgba(255, 223, 186, 1) 75%,\n    rgba(212, 175, 55, 1) 100%\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  /* No animation - static elegant text */\n  margin-bottom: 1rem;\n  text-transform: uppercase;\n}\n\n.luxury-subtitle {\n  font-family: 'Inter', sans-serif;\n  font-weight: 300;\n  font-size: 1.2rem;\n  color: #000000;\n  letter-spacing: 0.3em;\n  text-transform: uppercase;\n  margin-bottom: 1.5rem;\n}\n\n.luxury-accent-line {\n  width: 120px;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(212, 175, 55, 0.8) 25%,\n    rgba(255, 215, 0, 1) 50%,\n    rgba(212, 175, 55, 0.8) 75%,\n    transparent 100%\n  );\n  margin: 0 auto;\n  /* No animation - static accent line */\n}\n\n@keyframes shimmerText {\n  0%, 100% {\n    background-position: 0% center;\n  }\n  50% {\n    background-position: 100% center;\n  }\n}\n\n@keyframes pulseWidth {\n  0%, 100% {\n    transform: scaleX(1);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scaleX(1.2);\n    opacity: 1;\n  }\n}\n\n/* Navigation Grid System */\n.navigation-grid {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: grid;\n  grid-template-columns: repeat(2, 200px);\n  grid-template-rows: repeat(2, 100px);\n  gap: 20px;\n  z-index: 20;\n}\n\n.nav-button {\n  background: rgba(0, 0, 0, 0.9);\n  border: 2px solid rgba(212, 175, 55, 0.5);\n  clip-path: polygon(\n    12px 0,\n    100% 0,\n    100% calc(100% - 12px),\n    calc(100% - 12px) 100%,\n    0 100%,\n    0 12px\n  );\n  padding: 1.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.nav-button:hover {\n  background: rgba(10, 10, 10, 0.95);\n  border-color: rgba(212, 175, 55, 0.9);\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 20px rgba(0, 0, 0, 0.8),\n    0 0 0 1px rgba(212, 175, 55, 0.3) inset;\n}\n\n.nav-button.visited {\n  background: rgba(0, 0, 0, 0.7);\n  border-color: rgba(212, 175, 55, 0.3);\n}\n\n.nav-icon {\n  font-size: 2.5rem;\n  color: rgba(212, 175, 55, 0.9);\n  margin-bottom: 0.5rem;\n}\n\n.nav-button h3 {\n  font-family: 'Playfair Display', serif;\n  font-size: 0.9rem;\n  font-weight: 400;\n  letter-spacing: 0.08em;\n  margin: 0;\n  color: white;\n  text-align: center;\n}\n\n.visited-indicator {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  font-size: 0.6rem;\n  color: rgba(212, 175, 55, 0.7);\n  letter-spacing: 0.1em;\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n}\n\n/* Legacy button styles - removed */\n\n/* Remove old hotspot styles */\n.hotspot-button:hover {\n  background: linear-gradient(\n    135deg,\n    rgba(30, 30, 30, 0.9) 0%,\n    rgba(50, 50, 50, 0.8) 100%\n  );\n  border-color: rgba(212, 175, 55, 0.7);\n  transform: translate(-50%, -50%) scale(1.1);\n  box-shadow:\n    0 8px 40px rgba(0, 0, 0, 0.7),\n    0 0 40px rgba(212, 175, 55, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n/* Remove old hotspot button animations */\n.hotspot-glow {\n  display: none;\n}\n\n/* Inventory Modal */\n.inventory-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    135deg,\n    rgba(0, 0, 0, 0.95) 0%,\n    rgba(10, 10, 10, 0.98) 100%\n  );\n  backdrop-filter: blur(30px) saturate(200%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 80;\n  animation: fadeIn 0.3s ease;\n}\n\n.inventory-container {\n  background: linear-gradient(\n    145deg,\n    rgba(15, 15, 15, 0.98) 0%,\n    rgba(25, 25, 25, 0.95) 50%,\n    rgba(15, 15, 15, 0.98) 100%\n  );\n  border-radius: 0;\n  padding: 3rem;\n  max-width: 1200px;\n  width: 90%;\n  max-height: 85vh;\n  overflow-y: auto;\n  position: relative;\n  border: 1px solid rgba(212, 175, 55, 0.4);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 25px 80px rgba(0, 0, 0, 0.8),\n    0 10px 25px rgba(0, 0, 0, 0.9),\n    0 0 100px rgba(212, 175, 55, 0.1);\n  clip-path: polygon(\n    20px 0,\n    100% 0,\n    100% calc(100% - 20px),\n    calc(100% - 20px) 100%,\n    0 100%,\n    0 20px\n  );\n}\n\n.inventory-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100px;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.05) 0%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n.inventory-container h2 {\n  font-family: 'Playfair Display', serif;\n  font-size: 2.5rem;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 2rem;\n  letter-spacing: 0.08em;\n  background: linear-gradient(90deg, #d4af37, #fff, #d4af37);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.inventory-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-bottom: 3rem;\n}\n\n.product-card {\n  background: linear-gradient(\n    145deg,\n    rgba(255, 255, 255, 0.08) 0%,\n    rgba(255, 255, 255, 0.02) 100%\n  );\n  border: 1px solid rgba(212, 175, 55, 0.2);\n  border-radius: 0;\n  padding: 2rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  clip-path: polygon(\n    10px 0,\n    100% 0,\n    100% calc(100% - 10px),\n    calc(100% - 10px) 100%,\n    0 100%,\n    0 10px\n  );\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.05) inset,\n    0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.product-card::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(\n    45deg,\n    transparent 30%,\n    rgba(255, 255, 255, 0.1) 50%,\n    transparent 70%\n  );\n  transform: rotate(45deg) translateY(-100%);\n  transition: transform 0.6s ease;\n  pointer-events: none;\n}\n\n.product-card:hover {\n  transform: translateY(-5px) scale(1.02);\n  background: linear-gradient(\n    145deg,\n    rgba(255, 255, 255, 0.12) 0%,\n    rgba(255, 255, 255, 0.05) 100%\n  );\n  border-color: rgba(212, 175, 55, 0.5);\n  box-shadow:\n    0 0 0 1px rgba(212, 175, 55, 0.3) inset,\n    0 8px 25px rgba(0, 0, 0, 0.5),\n    0 0 40px rgba(212, 175, 55, 0.1);\n}\n\n.product-card:hover::before {\n  transform: rotate(45deg) translateY(100%);\n}\n\n.product-card.out-of-stock {\n  opacity: 0.6;\n}\n\n.product-image {\n  font-size: 4rem;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.product-card h3 {\n  color: white;\n  font-size: 1.3rem;\n  font-weight: 400;\n  margin-bottom: 0.5rem;\n}\n\n.product-price {\n  color: #ffd700;\n  font-size: 1.2rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\n.product-desc {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.9rem;\n}\n\n.stock-badge {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: rgba(255, 0, 0, 0.8);\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.inventory-actions {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.glass-button {\n  background: linear-gradient(\n    145deg,\n    rgba(255, 255, 255, 0.15) 0%,\n    rgba(255, 255, 255, 0.05) 50%,\n    rgba(255, 255, 255, 0.08) 100%\n  );\n  border: 1px solid rgba(212, 175, 55, 0.4);\n  color: white;\n  padding: 1rem 2.5rem;\n  cursor: pointer;\n  font-size: 1rem;\n  font-family: 'Inter', sans-serif;\n  font-weight: 300;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  clip-path: polygon(\n    15px 0,\n    100% 0,\n    100% calc(100% - 15px),\n    calc(100% - 15px) 100%,\n    0 100%,\n    0 15px\n  );\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 4px 15px rgba(0, 0, 0, 0.5),\n    0 0 30px rgba(212, 175, 55, 0.1);\n}\n\n.button-shine {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.3) 50%,\n    transparent 100%\n  );\n  transition: left 0.5s ease;\n  pointer-events: none;\n}\n\n.glass-button:hover .button-shine {\n  left: 100%;\n}\n\n.action-btn {\n  background: linear-gradient(135deg,\n    rgba(255, 255, 255, 0.1) 0%,\n    rgba(255, 255, 255, 0.05) 100%);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 1rem 2rem;\n  border-radius: 50px;\n  cursor: pointer;\n  font-size: 1rem;\n  letter-spacing: 0.02em;\n  transition: all 0.3s ease;\n}\n\n.glass-button:hover {\n  background: linear-gradient(\n    145deg,\n    rgba(255, 255, 255, 0.2) 0%,\n    rgba(255, 255, 255, 0.1) 50%,\n    rgba(255, 255, 255, 0.15) 100%\n  );\n  border-color: rgba(212, 175, 55, 0.6);\n  transform: translateY(-2px) scale(1.02);\n  box-shadow:\n    0 0 0 1px rgba(212, 175, 55, 0.3) inset,\n    0 8px 25px rgba(0, 0, 0, 0.7),\n    0 0 50px rgba(212, 175, 55, 0.2);\n}\n\n.action-btn:hover {\n  background: linear-gradient(135deg,\n    rgba(255, 255, 255, 0.15) 0%,\n    rgba(255, 255, 255, 0.08) 100%);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n/* Product Detail Modal */\n.product-detail-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 90;\n  animation: fadeIn 0.3s ease;\n}\n\n.product-detail {\n  background: rgba(10, 10, 10, 0.4);\n  backdrop-filter: blur(30px) saturate(200%);\n  border-radius: 0;\n  padding: 3rem;\n  max-width: 900px;\n  width: 90%;\n  position: relative;\n  border: 2px solid rgba(212, 175, 55, 0.5);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 30px 90px rgba(0, 0, 0, 0.9),\n    0 15px 35px rgba(0, 0, 0, 0.8),\n    0 0 120px rgba(212, 175, 55, 0.15);\n  clip-path: polygon(\n    30px 0,\n    100% 0,\n    100% calc(100% - 30px),\n    calc(100% - 30px) 100%,\n    0 100%,\n    0 30px\n  );\n}\n\n/* No gradient background - clean design */\n\n.product-showcase {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.product-360 {\n  text-align: center;\n}\n\n.rotating-product {\n  font-size: 8rem;\n  display: inline-block;\n  color: #d4af37;\n  transition: transform 0.3s ease;\n  /* No animation - static display */\n}\n\n.rotate-hint {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 0.9rem;\n  margin-top: 1rem;\n}\n\n.product-info h1 {\n  color: white;\n  font-size: 2rem;\n  font-weight: 400;\n  margin-bottom: 1rem;\n  letter-spacing: 0.02em;\n}\n\n.product-info .price {\n  color: #ffd700;\n  font-size: 1.8rem;\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n\n.product-info .description {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n}\n\n.product-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.btn-primary,\n.btn-secondary {\n  padding: 1rem 2rem;\n  border-radius: 50px;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  letter-spacing: 0.02em;\n}\n\n.btn-primary {\n  background: linear-gradient(\n    145deg,\n    rgba(255, 255, 255, 0.15) 0%,\n    rgba(255, 255, 255, 0.08) 50%,\n    rgba(255, 255, 255, 0.12) 100%\n  );\n  color: #d4af37;\n  font-weight: 500;\n  border: 1px solid rgba(212, 175, 55, 0.5);\n}\n\n.btn-primary:hover {\n  background: linear-gradient(\n    145deg,\n    rgba(212, 175, 55, 0.25) 0%,\n    rgba(212, 175, 55, 0.15) 50%,\n    rgba(212, 175, 55, 0.2) 100%\n  );\n  transform: translateY(-2px) scale(1.02);\n  box-shadow:\n    0 10px 30px rgba(0, 0, 0, 0.4),\n    0 0 40px rgba(212, 175, 55, 0.15);\n  border-color: rgba(212, 175, 55, 0.7);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.sold-out-message p {\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 1rem;\n  font-style: italic;\n}\n\n/* Close Button */\n.close-btn {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: linear-gradient(\n    145deg,\n    rgba(255, 255, 255, 0.15) 0%,\n    rgba(255, 255, 255, 0.05) 100%\n  );\n  border: 1px solid rgba(212, 175, 55, 0.3);\n  color: #d4af37;\n  width: 45px;\n  height: 45px;\n  font-size: 1.8rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  clip-path: polygon(\n    8px 0,\n    100% 0,\n    100% calc(100% - 8px),\n    calc(100% - 8px) 100%,\n    0 100%,\n    0 8px\n  );\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 4px 12px rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-btn:hover {\n  background: linear-gradient(\n    145deg,\n    rgba(212, 175, 55, 0.2) 0%,\n    rgba(212, 175, 55, 0.1) 100%\n  );\n  transform: rotate(90deg) scale(1.1);\n  border-color: rgba(212, 175, 55, 0.5);\n  box-shadow:\n    0 0 0 1px rgba(212, 175, 55, 0.3) inset,\n    0 6px 20px rgba(0, 0, 0, 0.7),\n    0 0 30px rgba(212, 175, 55, 0.2);\n}\n\n/* Playing Indicator */\n.playing-indicator {\n  position: fixed;\n  bottom: 2rem;\n  left: 2rem;\n  background: rgba(0, 0, 0, 0.9);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(212, 175, 55, 0.4);\n  border-radius: 0;\n  clip-path: polygon(\n    0 8px,\n    8px 0,\n    100% 0,\n    100% calc(100% - 8px),\n    calc(100% - 8px) 100%,\n    0 100%\n  );\n  padding: 0.75rem 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  z-index: 60;\n  animation: slideDown 0.5s ease;\n}\n\n.playing-dot {\n  width: 8px;\n  height: 8px;\n  background: #ff4444;\n  border-radius: 50%;\n  animation: pulse 1.5s ease infinite;\n}\n\n.playing-indicator span {\n  color: rgba(212, 175, 55, 0.9);\n  font-family: 'Inter', sans-serif;\n  font-size: 0.9rem;\n  letter-spacing: 0.05em;\n  font-weight: 300;\n}\n\n/* Location Indicator */\n.location-indicator {\n  position: fixed;\n  bottom: 8rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.9);\n  backdrop-filter: blur(10px);\n  border: 2px solid rgba(212, 175, 55, 0.4);\n  clip-path: polygon(\n    0 10px,\n    10px 0,\n    100% 0,\n    100% calc(100% - 10px),\n    calc(100% - 10px) 100%,\n    0 100%\n  );\n  padding: 1.5rem 2rem;\n  z-index: 35;\n  animation: slideUp 0.5s ease;\n}\n\n.location-indicator h3 {\n  font-family: 'Playfair Display', serif;\n  color: rgba(212, 175, 55, 0.9);\n  font-size: 1.2rem;\n  font-weight: 400;\n  margin-bottom: 1rem;\n  text-align: center;\n  letter-spacing: 0.05em;\n}\n\n.location-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.location-actions button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.location-actions button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n/* Sharp Mini Map */\n.sharp-minimap {\n  position: fixed;\n  top: 5rem;\n  left: 1rem;\n  background: rgba(0, 0, 0, 0.95);\n  border: 2px solid rgba(212, 175, 55, 0.4);\n  clip-path: polygon(\n    0 10px,\n    10px 0,\n    100% 0,\n    100% calc(100% - 10px),\n    calc(100% - 10px) 100%,\n    0 100%\n  );\n  padding: 1rem;\n  width: 220px;\n  z-index: 50;\n  box-shadow:\n    0 0 0 1px rgba(212, 175, 55, 0.2),\n    0 4px 12px rgba(0, 0, 0, 0.8);\n}\n\n.map-title {\n  font-family: 'Inter', sans-serif;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  color: rgba(212, 175, 55, 0.9);\n  text-transform: uppercase;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.3rem;\n  border-bottom: 1px solid rgba(212, 175, 55, 0.2);\n}\n\n.map-svg {\n  width: 100%;\n  height: 120px;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.map-node {\n  transition: all 0.3s ease;\n}\n\n.map-node.active rect {\n  fill: rgba(212, 175, 55, 0.3);\n  stroke: rgba(212, 175, 55, 1);\n  stroke-width: 2;\n  filter: drop-shadow(0 0 4px rgba(212, 175, 55, 0.8));\n}\n\n.map-node.visited rect {\n  stroke-dasharray: 5,2;\n}\n\n.map-legend {\n  margin-top: 0.5rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid rgba(212, 175, 55, 0.2);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.current-loc {\n  font-family: 'Inter', sans-serif;\n  font-size: 0.65rem;\n  color: rgba(212, 175, 55, 0.8);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n/* Old mini-map styles removed - sharp-minimap is always visible */\n\n.map-point {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  transition: all 0.3s ease;\n}\n\n.map-point.entrance {\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.map-point.diamonds {\n  top: 10px;\n  left: 20%;\n}\n\n.map-point.watches {\n  top: 10px;\n  right: 20%;\n}\n\n.map-point.active {\n  background: rgba(255, 215, 0, 0.8);\n  border-color: #ffd700;\n  box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);\n}\n\n.map-point span {\n  color: white;\n  font-size: 0.7rem;\n}\n\n.map-path {\n  position: absolute;\n  width: 2px;\n  background: rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.map-path.left {\n  height: 70px;\n  bottom: 30px;\n  left: 30%;\n  transform: rotate(-20deg);\n}\n\n.map-path.right {\n  height: 70px;\n  bottom: 30px;\n  right: 30%;\n  transform: rotate(20deg);\n}\n\n.map-path.active {\n  background: rgba(255, 215, 0, 0.6);\n}\n\n/* Ambient Glow */\n.ambient-glow {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 5;\n  opacity: 0.3;\n}\n\n.diamond-glow {\n  background: radial-gradient(circle at center,\n    rgba(135, 206, 235, 0.2) 0%,\n    transparent 70%);\n  animation: glowPulse 4s ease infinite;\n}\n\n.watch-glow {\n  background: radial-gradient(circle at center,\n    rgba(255, 215, 0, 0.2) 0%,\n    transparent 70%);\n  animation: glowPulse 4s ease infinite;\n}\n\n/* Animations */\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n@keyframes pulse-ring {\n  0% {\n    transform: translate(-50%, -50%) scale(0.8);\n    opacity: 1;\n  }\n  50% {\n    transform: translate(-50%, -50%) scale(1.2);\n    opacity: 0.3;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(0.8);\n    opacity: 1;\n  }\n}\n\n@keyframes gentleSpin {\n  from { transform: rotateY(0deg); }\n  to { transform: rotateY(360deg); }\n}\n\n@keyframes glowPulse {\n  0%, 100% { opacity: 0.3; }\n  50% { opacity: 0.5; }\n}\n\n/* ========================================\n   RESPONSIVE DESIGN - Mobile First Approach\n   ======================================== */\n\n/* Tablet and smaller (768px and below) */\n@media (max-width: 768px) {\n  /* Speed control adjustments - move to safe area */\n  .speed-control {\n    position: fixed;\n    bottom: auto;\n    top: auto;\n    right: auto;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 100px; /* Above the bottom controls */\n    padding: 0.5rem 0.8rem;\n    gap: 0.4rem;\n    z-index: 50; /* Ensure it's above other elements */\n    background: linear-gradient(\n      135deg,\n      rgba(10, 10, 10, 0.95),\n      rgba(20, 20, 20, 0.9)\n    );\n    flex-direction: row;\n    align-items: center;\n    max-width: 90%;\n  }\n\n  .speed-control span {\n    font-size: 0.75rem;\n    display: inline-block;\n    margin-right: 0.5rem;\n  }\n\n  .speed-control button {\n    padding: 0.3rem 0.5rem;\n    font-size: 0.75rem;\n    min-width: 35px;\n  }\n  .persistent-header {\n    top: 1rem;\n  }\n\n  .luxury-title {\n    font-size: 2.5rem;\n  }\n\n  .luxury-subtitle {\n    font-size: 1rem;\n  }\n\n\n  .inventory-grid {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 1.5rem;\n  }\n\n  .product-showcase {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .product-detail {\n    padding: 2rem;\n    width: 95%;\n  }\n\n  .location-indicator {\n    bottom: 1rem;\n    padding: 1rem;\n    width: 90%;\n  }\n\n  .location-actions {\n    flex-direction: row;\n    gap: 0.5rem;\n  }\n\n  .location-actions button {\n    padding: 0.5rem 1rem;\n    font-size: 0.85rem;\n  }\n}\n\n/* Mobile (480px and below) */\n@media (max-width: 480px) {\n  /* Adjust speed control for small mobile screens */\n  .speed-control {\n    position: fixed;\n    bottom: 90px; /* Above bottom navigation */\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 0.4rem 0.6rem;\n    gap: 0.3rem;\n    max-width: 280px;\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    background: linear-gradient(\n      135deg,\n      rgba(10, 10, 10, 0.98),\n      rgba(20, 20, 20, 0.95)\n    );\n    border: 1px solid rgba(212, 175, 55, 0.3);\n    display: flex !important; /* Ensure it's visible */\n    align-items: center;\n    justify-content: center;\n    z-index: 45; /* Below modals but above video */\n  }\n\n  .speed-control span {\n    font-size: 0.7rem;\n    margin-right: 0.3rem;\n    color: rgba(212, 175, 55, 0.9);\n  }\n\n  .speed-control button {\n    padding: 0.25rem 0.35rem;\n    font-size: 0.65rem;\n    min-width: 28px;\n  }\n\n  .speed-icon {\n    font-size: 0.9rem;\n    margin-right: 0.3rem;\n  }\n  .luxury-title {\n    font-size: 2rem;\n  }\n\n  .luxury-subtitle {\n    font-size: 0.9rem;\n    letter-spacing: 0.2em;\n  }\n\n\n  .inventory-grid {\n    grid-template-columns: 1fr;\n    padding: 0 1rem;\n  }\n\n  .inventory-modal {\n    padding: 0;\n  }\n\n  .inventory-container {\n    width: 100%;\n    height: 100vh;\n    max-height: 100vh;\n    padding: 4rem 1rem 1rem;\n    border: none;\n    clip-path: none;\n    border-radius: 0;\n    overflow-y: auto;\n  }\n\n  .inventory-container h2 {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  .product-card {\n    padding: 1.2rem;\n  }\n\n  .product-detail-modal {\n    padding: 0;\n  }\n\n  .product-detail {\n    width: 100%;\n    height: 100vh;\n    max-height: 100vh;\n    padding: 4rem 1rem 1rem;\n    border: none;\n    clip-path: none;\n    border-radius: 0;\n    overflow-y: auto;\n  }\n\n  .product-showcase {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .rotating-product {\n    font-size: 5rem;\n  }\n\n  .close-btn {\n    position: fixed;\n    top: 1rem;\n    right: 1rem;\n    padding: 0.8rem;\n    font-size: 1.5rem;\n    background: rgba(0, 0, 0, 0.95);\n    border: 2px solid rgba(212, 175, 55, 0.6);\n    z-index: 100;\n  }\n\n  .playing-indicator {\n    bottom: 1rem;\n    left: 1rem;\n    right: auto;\n    transform: none;\n    padding: 0.5rem 0.8rem;\n    font-size: 0.8rem;\n    max-width: 180px;\n  }\n\n  .playing-indicator span {\n    font-size: 0.8rem;\n  }\n\n  /* Location indicator adjustments */\n  .location-indicator {\n    bottom: 10rem;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 85%;\n    padding: 0.8rem;\n  }\n}\n\n/* iPhone SE and similar small phones (375px and below) */\n@media (max-width: 375px) {\n  /* Critical mobile layout - no overlaps */\n\n  /* Speed control - keep visible but adjust position */\n  .speed-control {\n    bottom: 75px !important; /* Position carefully above controls */\n    padding: 0.35rem 0.5rem !important;\n    gap: 0.25rem !important;\n  }\n\n  /* Playing indicator - bottom left */\n  .playing-indicator {\n    bottom: 0.5rem;\n    left: 0.5rem;\n    padding: 0.4rem 0.6rem;\n    font-size: 0.7rem;\n    max-width: 150px;\n  }\n\n  .playing-indicator span {\n    font-size: 0.65rem;\n  }\n\n  .walking-icon {\n    font-size: 0.7rem;\n  }\n\n  /* Location indicator - above playing indicator */\n  .location-indicator {\n    bottom: 3.5rem;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 90%;\n    padding: 0.6rem;\n  }\n\n  .location-indicator h3 {\n    font-size: 0.8rem;\n  }\n\n  /* Navigation grid - centered */\n  .navigation-grid {\n    top: 55%;\n  }\n\n  /* Sound toggle - bottom right */\n  .sound-toggle {\n    position: fixed;\n    bottom: 0.5rem;\n    right: 0.5rem;\n    padding: 0.5rem;\n    font-size: 1rem;\n    z-index: 35;\n  }\n  .persistent-header {\n    top: 0.5rem;\n  }\n\n  .luxury-title {\n    font-size: 1.8rem;\n  }\n\n  .luxury-subtitle {\n    font-size: 0.8rem;\n    letter-spacing: 0.15em;\n    margin-bottom: 1rem;\n  }\n\n  .luxury-accent-line {\n    width: 80px;\n  }\n\n  .title-particles {\n    width: 300px;\n    height: 100px;\n  }\n\n\n  .inventory-container {\n    padding: 1.5rem 1rem;\n    width: 100%;\n    max-width: 100%;\n    height: 100vh;\n    overflow-y: auto;\n  }\n\n  .inventory-container h2 {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  .product-card h3 {\n    font-size: 1rem;\n  }\n\n  .product-price {\n    font-size: 0.9rem;\n  }\n\n  .product-detail {\n    padding: 1.5rem;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n  }\n\n  .product-info h1 {\n    font-size: 1.5rem;\n  }\n\n  .product-360 {\n    margin-bottom: 1rem;\n  }\n\n  .rotating-product {\n    font-size: 5rem;\n  }\n\n  .playing-indicator {\n    bottom: 1rem;\n    padding: 0.4rem 0.8rem;\n    width: 95%;\n  }\n\n  .walking-icon {\n    font-size: 0.8rem;\n  }\n\n  .location-indicator {\n    bottom: 0.5rem;\n    padding: 0.8rem;\n    width: 95%;\n  }\n\n  .location-indicator h3 {\n    font-size: 0.9rem;\n  }\n\n  .location-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .location-actions button {\n    width: 100%;\n    padding: 0.6rem;\n    font-size: 0.8rem;\n  }\n\n  .close-btn {\n    top: 0.5rem;\n    right: 0.5rem;\n    padding: 0.5rem;\n  }\n\n\n  /* Responsive Grid for Tablets */\n@media (max-width: 768px) {\n  .navigation-grid {\n    grid-template-columns: repeat(2, 160px);\n    grid-template-rows: repeat(2, 90px);\n    gap: 15px;\n  }\n\n  .nav-button {\n    padding: 1.2rem;\n  }\n\n  .nav-icon {\n    font-size: 2rem;\n  }\n\n  .nav-button h3 {\n    font-size: 0.85rem;\n  }\n}\n\n/* Responsive Grid for Mobile */\n@media (max-width: 480px) {\n  .navigation-grid {\n    grid-template-columns: repeat(2, 140px);\n    grid-template-rows: repeat(2, 80px);\n    gap: 12px;\n  }\n\n  .nav-button {\n    padding: 1rem;\n  }\n\n  .nav-icon {\n    font-size: 1.8rem;\n    margin-bottom: 0.3rem;\n  }\n\n  .nav-button h3 {\n    font-size: 0.75rem;\n  }\n\n  .visited-indicator {\n    font-size: 0.5rem;\n    top: 3px;\n    right: 5px;\n  }\n}\n\n/* Additional fix for navigation grid on small screens */\n@media (max-width: 375px) {\n  .navigation-grid {\n    grid-template-columns: repeat(2, 110px);\n    grid-template-rows: repeat(2, 70px);\n    gap: 8px;\n    top: 50%;\n  }\n\n  .nav-button {\n    padding: 0.8rem;\n    clip-path: polygon(\n      8px 0,\n      100% 0,\n      100% calc(100% - 8px),\n      calc(100% - 8px) 100%,\n      0 100%,\n      0 8px\n    );\n  }\n\n  .nav-icon {\n    font-size: 1.5rem;\n    margin-bottom: 0.2rem;\n  }\n\n  .nav-button h3 {\n    font-size: 0.65rem;\n    letter-spacing: 0.05em;\n  }\n\n  .visited-indicator {\n    display: none; /* Hide on very small screens */\n  }\n\n  .nav-button.visited::after {\n    content: '';\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    width: 6px;\n    height: 6px;\n    background: rgba(212, 175, 55, 0.8);\n    border-radius: 50%;\n  }\n}\n\n/* Responsive minimap */\n  .sharp-minimap {\n    top: 4.5rem;\n    width: 180px;\n    padding: 0.7rem;\n  }\n\n  .map-svg {\n    height: 90px;\n  }\n\n  .map-title {\n    font-size: 0.6rem;\n  }\n\n  .current-loc {\n    font-size: 0.6rem;\n  }\n\n  .loading-content h2 {\n    font-size: 1.3rem;\n  }\n\n  .loading-content p {\n    font-size: 0.8rem;\n  }\n}\n\n/* Floor Plan Controls */\n.map-close-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: transparent;\n  border: 1px solid rgba(212, 175, 55, 0.4);\n  color: rgba(212, 175, 55, 0.8);\n  padding: 0.2rem 0.3rem;\n  cursor: pointer;\n  font-size: 0.8rem;\n  transition: all 0.2s ease;\n  z-index: 10;\n}\n\n.map-close-btn:hover {\n  background: rgba(212, 175, 55, 0.1);\n  color: rgba(212, 175, 55, 1);\n}\n\n.floor-plan-toggle {\n  position: fixed;\n  top: 6rem;\n  left: 1rem;\n  background: rgba(0, 0, 0, 0.9);\n  border: 2px solid rgba(212, 175, 55, 0.4);\n  color: rgba(212, 175, 55, 0.9);\n  padding: 0.8rem 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: 'Inter', sans-serif;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  transition: all 0.2s ease;\n  z-index: 40;\n  clip-path: polygon(\n    0 8px,\n    8px 0,\n    100% 0,\n    100% calc(100% - 8px),\n    calc(100% - 8px) 100%,\n    0 100%\n  );\n}\n\n.floor-plan-toggle:hover {\n  background: rgba(10, 10, 10, 0.95);\n  border-color: rgba(212, 175, 55, 0.8);\n  transform: translateX(2px);\n}\n\n.floor-plan-toggle svg {\n  font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
